import React from "react";

import { IHelpBtn } from "../@types";
import TooltipButton from "../TooltipButton";
import { SEARCH_MODALS_NAMES } from "../../../search/hooks/useSearchModals";

export const HelpBtn = ({ onClick }: IHelpBtn) => (
  <TooltipButton
    onClick={() => onClick({ type: SEARCH_MODALS_NAMES.HELP })}
    type="help"
    label="Help"
  />
);
